export default "__VITE_ASSET__CaOs3wOm__"